import { Answer, globalRegions, PostAnswerBody } from 'altru-types';
import { Api } from '@/store/api';
import { Credentials } from '@/store/auth/types';

export async function getAnswer({
  answerId,
  authHeaders,
  region = 'us',
}: {
  answerId: string;
  authHeaders: Credentials;
  region: globalRegions;
}): Promise<Answer> {
  const response = await Api.get(`/api/${region}/answers/${answerId}`, {
    headers: authHeaders,
  });
  return response.data.data;
}

export async function postAnswer({
  postAnswerBody,
  headers,
  region,
}: {
  postAnswerBody: PostAnswerBody;
  headers: Credentials;
  region: globalRegions;
}): Promise<Answer> {
  const { question_id, user_id, assigner_id, status, max_duration, locale } = postAnswerBody;
  const response = await Api.post(
    `/api/${region}/answers`,
    {
      question_id,
      user_id,
      assigner_id,
      status,
      max_duration,
      locale,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
    },
  );
  return response.data.data;
}
